/**
 * Safe localStorage wrapper. Falls back to defaults on read failure,
 * silently ignores write failure (state works in-memory only for that session).
 */

/**
 * Read a value from localStorage, returning fallback on any failure.
 * @param {string} key
 * @param {*} fallback
 * @returns {*}
 */
export function safeStorageGet(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

/**
 * Format-tolerant read: tries JSON.parse first, falls back to raw string.
 * Handles both JSON-stringified ("\"dark\"") and plain string ("dark") values.
 * @param {string} key
 * @param {*} fallback
 * @returns {*}
 */
export function safeStorageGetTolerant(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    try { return JSON.parse(raw); } catch { return raw; }
  } catch {
    return fallback;
  }
}

/**
 * Write a value to localStorage. Silently ignores failures.
 * @param {string} key
 * @param {*} value
 */
export function safeStorageSet(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage unavailable (incognito, iframe sandbox, quota exceeded).
  }
}

/**
 * Remove a key from localStorage. Silently ignores failures.
 * @param {string} key
 */
export function safeStorageRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // Storage unavailable.
  }
}
